// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"708":"02810333","787":"9d681327"}[chunkId] + ".chunk.js";
};